import { h, Component, Fragment } from "preact";
import { msg } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import MoneyFormatter from "../utils/money-formatter";
import CashoutService from "../../../services/cashout";
import Ticket from "../../../services/ticket";
import Observer from "../utils/observer";

export class CashoutOptionsModal extends Component {
    modalRoot = null;

    componentDidMount() {
        window.document.addEventListener('click', this.outClickCb);
    }

    componentWillUnmount() {
        window.document.removeEventListener('click', this.outClickCb);
    }

    outClickCb = (e) => {
        if (this.modalRoot === null) {
            return;
        }

        if (!e.composedPath().includes(this.modalRoot)) {
            this.props.onClose(); // Chiama la funzione onClose passata come prop
        }
    };

    render({ children, row, onClose }) {
        return (
            <div ref={r => this.modalRoot = r} data-id={row.ticketId} class="absolute top-10 left-0 rounded w-[350px] z-20 bg-slate-100 shadow border border-gray-600">
                {children}
            </div>
        );
    }
}

/**
 * Richiede che i children abbiano l'attibuto "tabName"
 */
export class CashoutTabs extends Component {
    state = { activeTab: 0 };

    onTabChange(idx) {
        this.setState({ activeTab: idx });
    }

    render({ children }, { activeTab }) {
        return (
            <Fragment>
                <div class="flex items-center justify-center text-sm text-center bg-slate-200 rounded-t">
                    {children.map((child, index) => (
                        <a
                            key={index}
                            class={
                                "w-full hover:bg-slate-300 py-2 first:rounded-tl last:rounded-tr" +
                                (activeTab === index ? " border-b-2 border-kobaaccent-400" : "")
                            }
                            href="javascript:void(0);"
                            onClick={e => this.onTabChange(index)}
                        >
                            {child.props.tabName}
                        </a>
                    ))}
                </div>
                {/* Mostra il contenuto della tab attiva */}
                <div class="p-2">
                    {children[activeTab]}
                </div>
            </Fragment>
        );
    }
}

export class PartialCashoutTab extends Component {
    state = {
        bet: this.props.row.betAmount / 2,
        win: CashoutService.calculateCashoutWin(this.props.row) / 2,
        maxbet: this.props.row.betAmount,
        minbet: this.props.minbet,
        cashout: CashoutService.calculateCashoutWin(this.props.row),
        cashoutErrorMsgs: {
            'cannot-cashout-max-odds-exceeded': window.Translation(msg`Una o più quote superano il valore massimo consentito per poter effettuare il cashout`),
            'bet-not-found': window.Translation(msg`Scommessa non identificata. Impossibile procedere con il cashout`),
            'login': window.Translation(msg`Devi essere collegato al sito per poter usufruire del cashout`),
            'disabled': window.Translation(msg`Siamo spiacenti ma questa funzionalità non è abilitata`),
            'cannot-cashout': window.Translation(msg`La scommessa non rispetta i parametri per il cashout`),
            'outdated-events': window.Translation(msg`La scommessa non rispetta le legature o un evento al suo interno sta per iniziare`),
            'cannot-cashout:already-partially-cashouted': window.Translation(msg`Questa scommessa ha gia un cashout parziale in corso`),
            'cannot-cashout:not-your-ticket': window.Translation(msg`Questa scommessa non appartiene al tuo account`)
        }
    };

    confirmPartialCashout(ticket, amount) {
        if (!confirm("Are you sure you want to perform a Partial Cashout?"))
            return;

        return CashoutService.doPartialCashout(ticket, amount)
            .then(() => {
                this.setState({ cashoutvalue: false });
                this.props.onPartialCashout(ticket);
            })
            .catch(error => {
                alert(!!this.state.cashoutErrorMsgs[error] ? this.state.cashoutErrorMsgs[error] : error);
            });
    }

    render({ row }, { bet, win, minbet, maxbet, cashout }) {
        return (
            <Fragment>
                <h4 class="flex panel-h4-flex text-left" style="padding-bottom:1px">
                    <span class="panel-flex-title"><Trans>Partial Bet</Trans></span>
                    <span class="flex-shrink-0 text-right w-20">
                        <MoneyFormatter value={bet} currency={row.currency} />
                    </span>
                </h4>
                <h4 class="flex panel-h4-flex text-left" style="padding-top:1px">
                    <span class="panel-flex-title"><Trans>Cashout Win</Trans></span>
                    <span class="flex-shrink-0 text-right w-20">
                        <MoneyFormatter value={win} currency={row.currency} />
                    </span>
                </h4>
                <div class="relative py-2">
                    <Slider
                        minLabel={MoneyFormatter({ value: minbet, currency: row.currency })}
                        maxLabel={MoneyFormatter({ value: maxbet, currency: row.currency })}
                        startvalue={bet / row.betAmount}
                        onChange={percent => {
                            const newBet = maxbet * percent;
                            this.setState({
                                bet: newBet < minbet ? minbet : newBet,
                                win: CashoutService.calculateCashoutWin({ ...row, betAmount: newBet < minbet ? minbet : newBet })
                            });
                        }}
                    />
                </div>
                <div class="py-2">
                    <a
                        href="javascript:void(0)"
                        class={"inline-block py-1 px-4 text-xs font-bold rounded leading-5 button-minimal w-full grow bg-kobaaccent-500 text-center uppercase cursor-pointer hover:bg-kobaaccent-400"}
                        onClick={e => {
                            if (!!cashout) {
                                this.confirmPartialCashout(row, bet);
                            }
                        }}
                    >
                        {!!cashout ? <Trans>Confirm</Trans> : <i class="fa fa-lock" />}
                    </a>
                </div>
            </Fragment>
        );
    }
}

export class AutoCashoutTab extends Component {
    state = {
        dataloaded: false,
        allowmax: false,
        allowmin: false,
        min: '',
        max: '',
        minwin: 0.01,
        maxwin: this.props.row.maxWinAmount,
        cashoutErrorMsgs: {
            'cannot-cashout-max-odds-exceeded': window.Translation(msg`Una o più quote superano il valore massimo consentito per poter effettuare il cashout`),
            'bet-not-found': window.Translation(msg`Scommessa non identificata. Impossibile procedere con il cashout`),
            'login': window.Translation(msg`Devi essere collegato al sito per poter usufruire del cashout`),
            'disabled': window.Translation(msg`Siamo spiacenti ma questa funzionalità non è abilitata`),
            'cannot-cashout': window.Translation(msg`La scommessa non rispetta i parametri per il cashout`),
            'outdated-events': window.Translation(msg`La scommessa non rispetta le legature o un evento al suo interno sta per iniziare`)
        }
    };

    componentDidMount() {
        const { row } = this.props;
        CashoutService.getAutoCashoutInfo(this.props.ticket)
            .catch(error => {
                alert(!!this.state.cashoutErrorMsgs[error] ? this.state.cashoutErrorMsgs[error] : error);
            })
            .then(info => {
                this.setState({
                    dataloaded: true,
                    allowmax: !!info.max,
                    allowmin: !!info.min,
                    min: !!info.min ? info.min : row.betAmount,
                    max: !!info.max ? info.max : row.maxWinAmount
                });
            });
    }

    confirmAutoCashout(ticket, autoCashoutData) {
        const cancel = !autoCashoutData.allowmin && !autoCashoutData.allowmax;

        if (confirm(window.Translation(`Do you Confirm automatic cashout on ticket ?`) + "\n" + ticket.ticketId)) {
            CashoutService.doAutoCashout(
                ticket,
                !!autoCashoutData.allowmin ? autoCashoutData.min : null,
                !!autoCashoutData.allowmax ? autoCashoutData.max : null,
                cancel
            )
                .catch(error => {
                    alert(!!this.state.cashoutErrorMsgs[error] ? this.state.cashoutErrorMsgs[error] : error);
                })
                .then(() => {
                    this.setState({});

                    if (cancel) {
                        alert(window.Translation(`Automatic cashout DISABLED`));
                    } else {
                        alert(window.Translation(`Automatic cashout ENABLED`));
                    }

                    this.props.onAutoCashout(ticket);
                });
        }
    }

    render({ row, ticket }, { allowmax, allowmin, min, max, maxwin }) {
        return (
            <div class="p-2 flex flex-col items-center justify-center text-base gap-1">
                <div class="py-2 w-full flex items-center justify-center gap-1">
                    <span>
                        <input
                            type="checkbox"
                            id={"max-" + ticket.ticketId}
                            checked={allowmax}
                            onClick={e => {
                                this.setState({ allowmax: !allowmax });
                            }}
                        />
                    </span>
                    <span class={"flex-shrink-0" + (!allowmax ? ' text-gray-400' : '')}>
                        <label htmlFor={"max-" + ticket.ticketId}><Trans>If the value reaches ( &gt;= )</Trans></label>
                    </span>
                    <span class="w-full text-right">
                        <span class={"mr-2" + (!allowmax ? ' text-gray-400' : '')}>{row.currency}</span>
                        <input
                            type="number"
                            disabled={!allowmax}
                            class={"w-20 rounded font-bold pl-2" + (!allowmax ? ' text-gray-400' : '') + (max > maxwin || max <= min ? ' border-2 border-red-500' : ' border border-slate-200')}
                            value={max}
                            placeholder={maxwin}
                            onInput={e => {
                                this.setState({ max: e.target.value });
                            }}
                        />
                    </span>
                </div>
                <div class="py-2 w-full flex items-center justify-center gap-1">
                    <span>
                        <input
                            type="checkbox"
                            id={"min-" + ticket.ticketId}
                            checked={allowmin}
                            onClick={e => {
                                this.setState({ allowmin: !allowmin });
                            }}
                        />
                    </span>
                    <span class={"flex-shrink-0" + (!allowmin ? ' text-gray-400' : '')}>
                        <label htmlFor={"min-" + ticket.ticketId}><Trans>If the value drops below ( &lt;= )</Trans></label>
                    </span>
                    <span class="w-full text-right">
                        <span class={"mr-2" + (!allowmin ? ' text-gray-400' : '')}>{row.currency}</span>
                        <input
                            type="number"
                            disabled={!allowmin}
                            class={"w-20 rounded font-bold pl-2" + (!allowmin ? ' text-gray-400' : '') + (min <= 0.00 || min >= max ? ' border-2 border-red-500' : ' border border-slate-200')}
                            value={min}
                            placeholder={row.betAmount}
                            onInput={e => {
                                this.setState({ min: e.target.value });
                            }}
                        />
                    </span>
                </div>
                <div class={"py-2 w-full pt-3" + ((!!min) || (!!max) ? '' : ' opacity-60')}>
                    <a
                        href="javascript:void(0)"
                        class={"inline-block py-1 px-4 text-xs font-bold rounded leading-5 button-minimal w-full grow bg-kobaaccent-500 text-center uppercase cursor-pointer hover:bg-kobaaccent-400"}
                        onClick={e => {
                            if ((!!min) || (!!max)) {
                                this.confirmAutoCashout(row, { allowmin, allowmax, min, max });
                            }
                        }}
                    >
                        <Trans>Confirm</Trans>
                    </a>
                </div>
            </div>
        );
    }
}

export class CashoutOptionsTooltip extends Component {
    render({ row, ticket, onClose, onPartialCashout, onAutoCashout }) {
        return (
            <CashoutOptionsModal row={row} onClose={onClose}>
                <CashoutOptionsContent
                    row={row}
                    ticket={ticket}
                    onPartialCashout={onPartialCashout}
                    onAutoCashout={onAutoCashout} />
            </CashoutOptionsModal>
        );
    }
}
export class CashoutOptionsContent extends Component {
    render({ row, ticket, onPartialCashout, onAutoCashout }) {
        return (
            <CashoutTabs>
                <PartialCashoutTab tabName={<Trans>Partial Cashout</Trans>} row={row} minbet={Ticket.getMinBetAfterTax()} onPartialCashout={onPartialCashout} />
                <AutoCashoutTab tabName={<Trans>Automatic Cashout</Trans>} row={row} ticket={ticket} onAutoCashout={onAutoCashout} />
            </CashoutTabs>
        );
    }
}

export class Slider extends Component {
    state = {
        steps: 5,
        selectedstep: 1,
        stepscolor: 'border-blue-400',
        dotscolor: 'bg-blue-700',
        minLabel: null,
        maxLabel: null,
        onChange: null,
        dotPosition: null,
        leftBoundaryPixels: null,
        rightBoundaryPixels: null,
        leftBoundaryElement: null,
        rightBoundaryElement: null,
        startvalue: null
    };

    componentWillMount() {
        this.updatePropsData(this.props);
    }

    componentWillReceiveProps(nextProps, nextContext) {
        this.updatePropsData(nextProps);
    }

    updatePropsData(props) {
        if (!!props.stepscolor) {
            this.setState({ stepscolor: props.stepscolor });
        }

        if (!!props.dotscolor) {
            this.setState({ dotscolor: props.dotscolor });
        }

        if (!!props.onChange) {
            this.setState({ onChange: props.onChange });
        }

        if (!!props.minLabel) {
            this.setState({ minLabel: props.minLabel });
        }

        if (!!props.maxLabel) {
            this.setState({ maxLabel: props.maxLabel });
        }

        if (!!props.startvalue) {
            this.setState({ startvalue: props.startvalue });
        }
    }

    getStepsArray() {
        const steps = [];

        for (let i = 1; i <= this.state.steps; ++i) {
            steps.push(
                <span class="h-3 w-3 flex items-center justify-center flex-shrink-0 flex-grow-0">
                    <span class={"h-full border-l-2 " + this.state.stepscolor + " flex-shrink-0 flex-grow-0"} />
                </span>
            );

            if (i !== this.state.steps) {
                steps.push(<span ref={r => i === 1 ? (this.stepDistanceElement = r) : null} class={"w-1/6 border-t-2 " + this.state.stepscolor + " flex-shrink-0 flex-grow-0"} />);
            }
        }

        return steps;
    }

    getDot() {
        return <a
            href="javascript:void(0)"
            onMouseDown={e => this.trackMouseSlide(e)}
            style={this.state.dotPosition !== null ? "left:" + this.state.dotPosition + "px" : ''}
            class={"absolute z-40 slider-dots h-3 w-3 rounded-full border-2 border-white " + this.state.dotscolor + " flex-shrink-0 flex-grow-0"}
        />;
    }

    getDotsArray() {
        const steps = [];
        let orderindex = 0;

        for (let i = 1; i <= this.state.steps; ++i) {
            steps.push(<a
                ref={r => i === 1 ? this.state.leftBoundaryElement = r : (i === this.state.steps ? this.state.rightBoundaryElement = r : null)}
                href="javascript:void(0)"
                onClick={e => { this.setState({ dotPosition: e.target.offsetLeft }); this.triggerCallback(e.target.offsetLeft); }}
                style={"order:" + (++orderindex)}
                class="slider-dots h-3 w-3 flex-shrink-0 flex-grow-0 relative"
            />);

            if (i !== this.state.steps) {
                steps.push(<span style={"order:" + (++orderindex)} class={"flex-shrink-0 flex-grow-0 w-1/6"} />);
            } else {
                if (
                    this.state.leftBoundaryElement !== null
                    && this.state.rightBoundaryElement !== null
                    && (!this.state.leftBoundaryPixels || !this.state.rightBoundaryPixels)
                ) {
                    let startposition = this.state.leftBoundaryElement.offsetLeft;

                    if (!!this.state.startvalue) {
                        startposition = Math.round(
                            (this.state.rightBoundaryElement.offsetLeft - this.state.leftBoundaryElement.offsetLeft)
                            * this.state.startvalue
                        ) + this.state.leftBoundaryElement.offsetLeft;
                    }

                    this.setState({
                        dotPosition: startposition,
                        leftBoundaryPixels: this.state.leftBoundaryElement.offsetLeft,
                        rightBoundaryPixels: this.state.rightBoundaryElement.offsetLeft
                    });
                }
            }
        }

        return steps;
    }

    triggerCallback(dotPosition) {
        if (!!this.state.onChange) {
            this.state.onChange(
                Math.round(
                    (dotPosition - this.state.leftBoundaryPixels)
                    / (this.state.rightBoundaryPixels - this.state.leftBoundaryPixels)
                    * 10000
                ) / 10000
            );
        }
    }

    trackMouseSlide(e) {
        if (!!this.props.disabled) {
            return;
        }

        //> Previene il bubbling degli eventi, che nel caso del mousedown causa la selezione del contenuto della pagina
        e.preventDefault();
        e.stopPropagation();

        //> Posizione iniziale del mouse al momento del click
        const mouseStartX = e.clientX; // - offset
        const startPosition = this.state.dotPosition;

        //> Registriamo l'evento di movimento del mouse
        window.document.addEventListener('mousemove', this.mouseTrackingListener = mouseMoveEvent => {
            let dotPosition = mouseMoveEvent.clientX - mouseStartX + startPosition;

            if (dotPosition < this.state.leftBoundaryPixels) {
                dotPosition = this.state.leftBoundaryPixels;
            }

            if (dotPosition > this.state.rightBoundaryPixels) {
                dotPosition = this.state.rightBoundaryPixels;
            }

            this.triggerCallback(dotPosition);
            this.setState({ dotPosition });
        });

        //> Registriamo l'evento per il rilascio del click del mouse
        window.document.addEventListener('mouseup', this.mouseUpListener = e => {
            //> Cancelliamo i listener di cui non abbiamo piu` bisogno
            window.document.removeEventListener('mousemove', this.mouseTrackingListener);
            window.document.removeEventListener('mouseup', this.mouseUpListener);
        });
    }

    render() {
        return <div>
            <div class="relative w-full">
                <div class="flex flex-row items-center justify-center w-full">
                    {this.getStepsArray()}
                </div>
                <div class="absolute left-0 top-0 right-0 bottom-0">
                    <div class="flex flex-row items-center justify-center w-full h-full">
                        {this.getDotsArray()}
                        {this.getDot()}
                    </div>
                </div>
            </div>
            {(!!this.state.maxLabel || !!this.state.minLabel) && <div class="flex flex-row items-center justify-center w-full">
                {!!this.state.minLabel && <span class="w-full text-left">{this.state.minLabel}</span>}
                {!!this.state.maxLabel && <span class="w-full text-right">{this.state.maxLabel}</span>}
            </div>}
        </div>;
    }
}
